"use client";


export function Logo6() {
  // return (
    // <section id="relume" className="px-[5%] py-12 md:py-16 lg:py-20">
      {/* <div className="container">
        <h1 className="mx-auto mb-8 w-full max-w-lg text-center text-base font-bold leading-[1.2] md:mb-10 md:text-md md:leading-[1.2] lg:mb-12">
          Trusted by compassionate pet lovers everywhere
        </h1>
        <div className="grid grid-cols-2 gap-2 md:grid-cols-3">
          <div className="flex w-full items-start justify-center justify-self-center bg-neutral-lightest px-4 pb-4 pt-[0.875rem] md:p-[0.875rem]">
            <img
              src="https://d22po4pjz3o32e.cloudfront.net/webflow-logo.svg"
              className="max-h-12 md:max-h-14"
              alt="Webflow logo 1"
            />
          </div>
          <div className="flex w-full items-start justify-center justify-self-center bg-neutral-lightest px-4 pb-4 pt-[0.875rem] md:p-[0.875rem]">
            <img
              src="https://d22po4pjz3o32e.cloudfront.net/relume-logo.svg"
              className="max-h-12 md:max-h-14"
              alt="Relume logo 1"
            />
          </div>
          <div className="flex w-full items-start justify-center justify-self-center bg-neutral-lightest px-4 pb-4 pt-[0.875rem] md:p-[0.875rem]">
            <img
              src="https://d22po4pjz3o32e.cloudfront.net/webflow-logo.svg"
              className="max-h-12 md:max-h-14"
              alt="Webflow logo 2"
            />
          </div>
          <div className="flex w-full items-start justify-center justify-self-center bg-neutral-lightest px-4 pb-4 pt-[0.875rem] md:p-[0.875rem]">
            <img
              src="https://d22po4pjz3o32e.cloudfront.net/relume-logo.svg"
              className="max-h-12 md:max-h-14"
              alt="Relume logo 2"
            />
          </div>
          <div className="flex w-full items-start justify-center justify-self-center bg-neutral-lightest px-4 pb-4 pt-[0.875rem] md:p-[0.875rem]">
            <img
              src="https://d22po4pjz3o32e.cloudfront.net/webflow-logo.svg"
              className="max-h-12 md:max-h-14"
              alt="Webflow logo 3"
            />
          </div>
          <div className="flex w-full items-start justify-center justify-self-center bg-neutral-lightest px-4 pb-4 pt-[0.875rem] md:p-[0.875rem]">
            <img
              src="https://d22po4pjz3o32e.cloudfront.net/relume-logo.svg"
              className="max-h-12 md:max-h-14"
              alt="Relume logo 3"
            />
          </div>
        </div>
      </div> */}
    // </section>
  // );
}
